import { UniqMap } from 'src/lib/UniqMap';
import { GENERATION_TOOL } from 'src/data/generationTool/const';
import { AI_SUGGESTION_MODE } from 'src/data/generation';

const DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE = new UniqMap();

/**
 * "product" data-driven tools
 */

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.facebookPrimaryTextProduct, {
  [AI_SUGGESTION_MODE.AIDA]: 2000,
  [AI_SUGGESTION_MODE.BAB]: 2000,
  [AI_SUGGESTION_MODE.FAB]: 2000,
  [AI_SUGGESTION_MODE.PAS]: 2000,
  [AI_SUGGESTION_MODE.engaging]: 2000,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.facebookHeadlineProduct, {
  [AI_SUGGESTION_MODE.creative]: 70,
  [AI_SUGGESTION_MODE.question]: 70,
  [AI_SUGGESTION_MODE.hook]: 70,
  [AI_SUGGESTION_MODE.callToAction]: 70,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.googleHeadlineProduct, {
  [AI_SUGGESTION_MODE.fluent]: 30,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.googleDescriptionProduct, {
  [AI_SUGGESTION_MODE.creative]: 90,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.outbrainHeadlineProduct, {
  [AI_SUGGESTION_MODE.creative]: 100,
  [AI_SUGGESTION_MODE.benefit]: 100,
  [AI_SUGGESTION_MODE.brand]: 100,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.taboolaHeadlineProduct, {
  [AI_SUGGESTION_MODE.creative]: 100,
  [AI_SUGGESTION_MODE.benefit]: 100,
  [AI_SUGGESTION_MODE.brand]: 100,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.twitterCopyProduct, {
  [AI_SUGGESTION_MODE.engaging]: 280,
  [AI_SUGGESTION_MODE.AIDA]: 280,
  [AI_SUGGESTION_MODE.PAS]: 280,
  [AI_SUGGESTION_MODE.list]: 280,
  [AI_SUGGESTION_MODE.creative]: 280,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.twitterTitleProduct, {
  [AI_SUGGESTION_MODE.engaging]: 70,
  [AI_SUGGESTION_MODE.creative]: 70,
  [AI_SUGGESTION_MODE.benefit]: 70,
  [AI_SUGGESTION_MODE.feature]: 70,
  [AI_SUGGESTION_MODE.pain]: 70,
  [AI_SUGGESTION_MODE.brand]: 70,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.linkedinIntroSingleImage, {
  [AI_SUGGESTION_MODE.engaging]: 600,
  [AI_SUGGESTION_MODE.AIDA]: 600,
  [AI_SUGGESTION_MODE.PAS]: 600,
  [AI_SUGGESTION_MODE.list]: 600,
  [AI_SUGGESTION_MODE.creative]: 600,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.linkedinHeadlineSingleImage, {
  [AI_SUGGESTION_MODE.engaging]: 200,
  [AI_SUGGESTION_MODE.creative]: 200,
  [AI_SUGGESTION_MODE.benefit]: 200,
  [AI_SUGGESTION_MODE.feature]: 200,
  [AI_SUGGESTION_MODE.pain]: 200,
  [AI_SUGGESTION_MODE.brand]: 200,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.pinterestDescriptionProduct, {
  [AI_SUGGESTION_MODE.engaging]: 500,
  [AI_SUGGESTION_MODE.creative]: 500,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.pinterestTitleProduct, {
  [AI_SUGGESTION_MODE.engaging]: 100,
  [AI_SUGGESTION_MODE.creative]: 100,
});

/**
 * "landing" data-driven tools
 */

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.landingHeadline, {
  [AI_SUGGESTION_MODE.standard]: 50,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.landingSubheader, {
  [AI_SUGGESTION_MODE.standard]: 150,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.landingCTA, {
  [AI_SUGGESTION_MODE.standard]: 20,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.landingBenefits, {
  [AI_SUGGESTION_MODE.list]: 1000,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.landingFeatures, {
  [AI_SUGGESTION_MODE.list]: 1000,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.landingSEOMetadata, {
  [AI_SUGGESTION_MODE.creative]: 160,
});

/**
 * "social" data-driven tools
 */

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.instagramCaption, {
  [AI_SUGGESTION_MODE.engaging]: 2000,
  [AI_SUGGESTION_MODE.AIDA]: 2000,
  [AI_SUGGESTION_MODE.PAS]: 2000,
  // [AI_SUGGESTION_MODE.BAB]: 2000, disabled for now until we have ac support
  // [AI_SUGGESTION_MODE.fourPs]: 2000, disabled for now until we have ac support
  [AI_SUGGESTION_MODE.oneTwoThreeFourFormula]: 2000,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.facebookPost, {
  [AI_SUGGESTION_MODE.engaging]: 2000,
  [AI_SUGGESTION_MODE.AIDA]: 2000,
  [AI_SUGGESTION_MODE.PAS]: 2000,
  [AI_SUGGESTION_MODE.BAB]: 2000,
  [AI_SUGGESTION_MODE.fourPs]: 2000,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.tweet, {
  [AI_SUGGESTION_MODE.engaging]: 280,
  [AI_SUGGESTION_MODE.hookBodyCta]: 280,
  [AI_SUGGESTION_MODE.list]: 280,
  [AI_SUGGESTION_MODE.summary]: 280,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.linkedinPost, {
  [AI_SUGGESTION_MODE.engaging]: 2000,
  [AI_SUGGESTION_MODE.AIDA]: 2000,
  [AI_SUGGESTION_MODE.PAS]: 2000,
  [AI_SUGGESTION_MODE.BAB]: 2000,
  [AI_SUGGESTION_MODE.fourPs]: 2000,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.pinterestPostDescription, {
  [AI_SUGGESTION_MODE.creative]: 500,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.pinterestPostTitle, {
  [AI_SUGGESTION_MODE.creative]: 100,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.emailSubject, {
  [AI_SUGGESTION_MODE.engaging]: 160,
});

DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.add(GENERATION_TOOL.emailBody, {
  [AI_SUGGESTION_MODE.engaging]: 2000,
});

export const getDefaultCharsByToolAndMode = (generationTool, suggestionMode) => {
  if (!generationTool || !suggestionMode) {
    return null;
  }
  const suggestionModes = DEFAULT_CHARS_PER_TOOL_AND_SUGGESTION_MODE.get(generationTool);
  return suggestionModes?.[suggestionMode];
};
